<div *ngIf="isLoading | async" id="loader">
  <div id="spinner"></div>
</div>
